<article [ngClass]="[needSaving ? 'not-saved' : 'saved', saving ? 'saving' : '']">
  <h2
    [ngClass]="['heading-underline', !loadTriggered ? 'clickable' : 'non-clickable']"
    [matTooltip]="!loadTriggered ? 'Click to expand.' : null"
    (click)="!loadTriggered ? expandAndLoad() : null">
    <div *ngIf="loadTriggered" class="back-button"
         [matTooltip]="needSaving ? unsavedChangesWarning : null"
         [matTooltipPosition]="'above'"
         (click)="router.navigate([dataToolsApps.DUPLIKIT_DASHBOARD])">
      <i class="bhi-previous"></i>
      <span>Back to {{dataToolsAppsTitles.DUPLIKIT_DASHBOARD}}</span>
    </div>
    {{dataToolsAppsTitles.DUPLIKIT}} Weights
    <span *ngIf="loadTriggered" class="sub-info">
      <a  (click)="router.navigate([dataToolsApps.DUPLIKIT_DASHBOARD])"
         [matTooltip]="'Return to ' + dataToolsAppsTitles.DUPLIKIT" matTooltipShowDelay="500">{{dataToolsAppsTitles.DUPLIKIT}}</a>
    </span>
    <span *ngIf="!loadTriggered" class="sub-info">Click to expand.</span>
  </h2>

  <div *ngIf="loadTriggered">
    <span *ngIf="loading; else loadComponent">
      <app-loading></app-loading>
    </span>
    <ng-template #loadComponent>
      <h3>Field Weights</h3>
      <table class="table table-striped table-no-border-bottom">
        <tr>
          <th></th>
          <th>Candidate</th>
          <th>Contact</th>
          <th>Company</th>
        </tr>
        <tr>
          <td>Threshold</td>
          <td class="thresholdValue">5</td> <!-- TODO: less replication. -->
          <td class="thresholdValue">5</td>
          <td class="thresholdValue">5</td>
        </tr>
        <tr>
          <td>SSN</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'ssn'}">
            </app-weight-value-selector>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Any Email</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'AnyEmail'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'AnyEmail'}">
            </app-weight-value-selector>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Any Phone</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'AnyPhone'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'AnyPhone'}">
            </app-weight-value-selector>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Phone</td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'phone'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>Fax</td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'fax'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>URL</td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'companyurl'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>First Name</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'first_name'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'first_name'}">
            </app-weight-value-selector>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Last Name</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'last_name'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'last_name'}">
            </app-weight-value-selector>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Full Name</td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'name'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>Clean Name</td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'sanitised_name'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>Date of Birth</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'date_of_birth'}">
            </app-weight-value-selector>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>Address Line 1</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'address1'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'address1'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'address1'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>Address Line 2</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'address2'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'address2'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'address2'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>City</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'city'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'city'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'city'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>State</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'state'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'state'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'state'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>Zip</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'zip'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'zip'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'zip'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>Country</td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'countryID'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'countryID'}">
            </app-weight-value-selector>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'countryID'}">
            </app-weight-value-selector>
          </td>
        </tr>
      </table>

      <h3>Custom Weights</h3>
      <table class="table table-striped table-no-border-bottom">
        <tr>
          <th></th>
          <th>Candidate</th>
          <th>Contact</th>
          <th>Company</th>
        </tr>
        <tr>
          <td>
            <app-weight-field [reference]="{entity: 'candidate', weightField: 'custom1'}">
            </app-weight-field>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'custom1'}">
            </app-weight-value-selector>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <app-weight-field [reference]="{entity: 'candidate', weightField: 'custom2'}">
            </app-weight-field>
          </td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'candidate', weightField: 'custom2'}">
            </app-weight-value-selector>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <app-weight-field [reference]="{entity: 'contact', weightField: 'custom1'}">
            </app-weight-field>
          </td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'custom1'}">
            </app-weight-value-selector>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <app-weight-field [reference]="{entity: 'contact', weightField: 'custom2'}">
            </app-weight-field>
          </td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'contact', weightField: 'custom2'}">
            </app-weight-value-selector>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <app-weight-field [reference]="{entity: 'company', weightField: 'custom1'}">
            </app-weight-field>
          </td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'custom1'}">
            </app-weight-value-selector>
          </td>
        </tr>
        <tr>
          <td>
            <app-weight-field [reference]="{entity: 'company', weightField: 'custom2'}">
            </app-weight-field>
          </td>
          <td></td>
          <td></td>
          <td>
            <app-weight-value-selector [reference]="{entity: 'company', weightField: 'custom2'}">
            </app-weight-value-selector>
          </td>
        </tr>
      </table>
    </ng-template>
  </div>
</article>
